import { RepayCreditDialog } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Repayment');
      },
      class:
        'h-[700px] bg-layer3-card [--header:60px] [&_.dialog-title]:!h-[60px] [&_.dialog-title]:!text-[18px] [&_.dialog-title]:!font-bold [&_.dialog-title]:!leading-[22px]',
    },
  },
};

export default RepayCreditDialog;
